import { React, useEffect, useState, useRef, useMemo, useCallback } from "react";
import cogoToast from "cogo-toast"; 
import { Spinner, Card, CardBody, CardHeader, Row, Col, Badge, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Button } from "reactstrap";
import { AgGridReact } from "ag-grid-react";
import { genericGet, genericPost, listBNFAttendance } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../Constants";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
 
const AttendanceList = (props) => {
  const history = useHistory();
  const {data,cycle} = (props.location && props.location.state) || {};
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [payload, setPayload] = useState(null);
  const [submission_result, setSubmission_result] = useState({});
  const [selectedCount, setSelectedCount] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [clockins, setClockins] = useState([]);
  const [isLoadingClockins, setIsLoadingClockins] = useState(false);
  const [selectedClockins, setSelectedClockins] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  
  const gridRef = useRef();
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);

const [startDate, setStartDate] = useState('')
const [endDate, setEndDate] = useState('')
const [clockinTime, setClockinTime] = useState('')

  useEffect(() => {
    if (cycle) {
      loadClockins();
    }
    return () => { };
  }, [cycle]);

  const loadClockins = () => {
    if (!cycle) {
      return;
    }
    
    setIsLoadingClockins(true);
    genericGet(`${ENDPOINTS.LIST_CLOCKINS}?cycle_id=${cycle}`, {})
      .then((res) => {
        setIsLoadingClockins(false);
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            setClockins(res.data.data || []);
            // Clear selections when data is refreshed
            setSelectedClockins([]);
          } else {
            cogoToast.error(res.data.message || 'Failed to load clock-ins', {});
          }
        } else {
          cogoToast.error("Connection error. Please try again.", {});
        }
      })
      .catch((err) => {
        setIsLoadingClockins(false);
        console.error(err);
        cogoToast.error("Failed to load clock-ins. Please try again.", {});
      });
  };

  const handleClockinSelection = (clockinId, isSelected) => {
    if (isSelected) {
      setSelectedClockins([...selectedClockins, clockinId]);
    } else {
      setSelectedClockins(selectedClockins.filter(id => id !== clockinId));
    }
  };

  const handleSelectAllClockins = (isSelected) => {
    if (isSelected) {
      setSelectedClockins(clockins.map(clockin => clockin.id));
    } else {
      setSelectedClockins([]);
    }
  };

  const handleDeleteClick = () => {
    if (selectedClockins.length === 0) {
      cogoToast.error("Please select at least one clock-in to delete");
      return;
    }
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    setIsDeleting(true);

    const payload = {
      clockin_ids: selectedClockins
    };

    genericPost(ENDPOINTS.DELETE_CLOCKIN, payload)
      .then((res) => {
        setIsDeleting(false);
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            const deletedCount = res.data.data?.length || selectedClockins.length;
            cogoToast.success(`Successfully deleted ${deletedCount} clock-in(s)`, {
              hideAfter: 5,
            });
            setSelectedClockins([]);
            // Refresh clock-ins list
            loadClockins();
          } else {
            cogoToast.error(res.data.message || 'Failed to delete clock-ins', {});
          }
        } else {
          cogoToast.error("Connection error. Please try again.", {});
        }
      })
      .catch((err) => {
        setIsDeleting(false);
        console.error(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

 


  
  const generateDateRange = (startDate, endDate, time) => {
    if (!startDate || !endDate || !time) {
      return [];
    }

    const dates = [];
    const start = new Date(startDate);
    const end = new Date(endDate);
    const [hours, minutes] = time.split(':');

    // Ensure end date is after start date
    if (end < start) {
      cogoToast.error("End date must be after start date");
      return [];
    }

    // Generate dates for each day in the range
    const currentDate = new Date(start);
    while (currentDate <= end) {
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      
      // Format: "YYYY-MM-DD HH:MM"
      const dateTimeString = `${year}-${month}-${day} ${hours}:${minutes}`;
      dates.push(dateTimeString);
      
      // Move to next day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  const generateJSON = () => {
    try {
      // Validate inputs
      if (!startDate || !endDate || !clockinTime) {
        cogoToast.error("Please select start date, end date, and time");
        return;
      }

      // Generate date range array
      const dateTimeArray = generateDateRange(startDate, endDate, clockinTime);
      
      if (dateTimeArray.length === 0) {
        cogoToast.error("Invalid date range");
        return;
      }

      const selectedRows = gridRef?.current?.api?.getSelectedRows() || [];
      if (selectedRows.length === 0) {
        cogoToast.error("Please select at least one beneficiary");
        return;
      }

      let payload = {
        cycle_id: cycle,
        clockin_date_time: dateTimeArray,
        bnf_list: []
      };

      selectedRows.forEach(bnf => {
        payload.bnf_list.push(bnf.beneficiary_inst_id);
      });
      
      setPayload(payload);
      setSelectedCount(selectedRows.length);
      cogoToast.success(`Generated attendance for ${dateTimeArray.length} date(s) and ${selectedRows.length} beneficiary(ies)`, { hideAfter: 3 });
    } catch (e) {
      console.error(e);
      cogoToast.error("Error generating attendance: " + e.message);
    }
  };

  const onBtExport = useCallback((e) => {
    gridRef.current.api.exportDataAsCsv(
      { allColumns: true });
  }, []);

  const onRowSelectionChanged = useCallback(() => {
    const selectedRows = gridRef?.current?.api?.getSelectedRows() || [];
    setSelectedCount(selectedRows.length);
  }, []);

  const handleSubmitClick = () => {
    if (payload?.bnf_list?.length < 1) {
      cogoToast.error("Please select beneficiaries first");
      return;
    }
    setShowConfirmModal(true);
  };

  const handleConfirmSubmit = () => {
    setShowConfirmModal(false);
    
    setIsLoading(true);
    if (payload == null && payload?.bnf_list?.length < 1) {
      setIsLoading(false);
      cogoToast.error("Please select beneficiaries first");
      return;
    }

    genericPost(ENDPOINTS.BNF_ATTENDANCE, payload)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            setSubmission_result(res.data);
            setIsSubmitted(true);
            cogoToast.success("Attendance Updated Successfully", {
              hideAfter: 5,
            });
            // Refresh clock-ins after successful submission
            loadClockins();
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return 'Not selected';
    const date = new Date(dateTimeString);
    return date.toLocaleString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };


  return (
    <div className="container-fluid">
      {/* Header Section */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="mb-1 text-primary">
                <i className="fas fa-clipboard-list me-2"></i>
                Attendance List
              </h2>
              <p className="text-muted mb-0">Manage beneficiary attendance for cycle</p>
            </div>
            <div className="d-flex gap-2">
              <Button 
                color="outline-primary" 
                onClick={onBtExport}
                className="d-flex align-items-center"
              >
                <i className="fas fa-download me-1"></i>
                Export Excel
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="row mb-3">
        <div className="col-12">
          <Breadcrumb className="bg-light p-2 rounded">
            <BreadcrumbItem>
              <Link to="/" className="text-decoration-none">
                <i className="fas fa-home me-1"></i>EBMS
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/" className="text-decoration-none">Cycle Attendance</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>Attendance List</BreadcrumbItem>
          </Breadcrumb>
        </div>
      </div>

      {/* Loading Spinner */}
      {isLoading && (
        <div className="d-flex justify-content-center my-4">
          <Spinner color="primary" size="lg" />
        </div>
      )}

      {/* Attendance Configuration Card */}
      <div className="row mb-4">
        <div className="col-12">
          <Card className="shadow-sm">
            <CardHeader className="bg-primary text-white">
              <h5 className="mb-0">
                <i className="fas fa-cog me-2"></i>
                Attendance Configuration
              </h5>
            </CardHeader>
            <CardBody>
              <Row>
                <Col md={4}>
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      <i className="fas fa-calendar-check me-1"></i>
                      Start Date
                    </label>
                    <input
                      type="date"
                      id="startDate"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      <i className="fas fa-calendar-times me-1"></i>
                      End Date
                    </label>
                    <input
                      type="date"
                      id="endDate"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      <i className="fas fa-clock me-1"></i>
                      Clock-in Time
                    </label>
                    <input
                      type="time"
                      id="clockinTime"
                      value={clockinTime}
                      onChange={(e) => setClockinTime(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12} className="d-flex justify-content-end">
                  <Button
                    color="primary"
                    onClick={generateJSON}
                    className="me-2"
                    disabled={!startDate || !endDate || !clockinTime}
                  >
                    <i className="fas fa-sync me-1"></i>
                    Generate Attendance
                  </Button>
                </Col>
              </Row>
              {payload && payload.clockin_date_time && (
                <Row className="mt-3">
                  <Col md={12}>
                    <Alert color="info" className="mb-0">
                      <i className="fas fa-info-circle me-2"></i>
                      <strong>Generated Dates:</strong> {payload.clockin_date_time.length} date(s) from {payload.clockin_date_time[0]} to {payload.clockin_date_time[payload.clockin_date_time.length - 1]}
                    </Alert>
                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </div>
      </div>

      {/* Selected Beneficiaries Summary */}
      {payload && (
        <div className="row mb-4">
          <div className="col-12">
            <Card className="shadow-sm border-success">
              <CardBody>
                <Row className="align-items-center">
                  <Col md={8}>
                    <div className="d-flex align-items-center">
                      <i className="fas fa-users text-success me-3 fs-4"></i>
                      <div>
                        <h5 className="mb-1 text-success">Selected Beneficiaries</h5>
                        <p className="mb-0 text-muted">
                          {selectedCount} beneficiary{selectedCount !== 1 ? 'ies' : ''} selected for attendance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={4} className="text-end">
                    <Badge color="success" className="fs-6 px-3 py-2">
                      {selectedCount} Selected
                    </Badge>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        </div>
      )}

      {/* Submission Status */}
      {isSubmitted && submission_result && (
        <div className="row mb-4">
          <div className="col-12">
            <Alert color="success" className="d-flex align-items-center">
              <i className="fas fa-check-circle me-2"></i>
              <div>
                <strong>Attendance submitted successfully!</strong>
                <br />
                <small>Attendance has been recorded for {selectedCount} beneficiaries.</small>
              </div>
            </Alert>
          </div>
        </div>
      )}

      {/* Submit Button */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <Button
              color="success"
              size="lg"
              disabled={!payload || payload?.bnf_list?.length < 1}
              onClick={handleSubmitClick}
              className="px-5"
            >
              <i className="fas fa-paper-plane me-2"></i>
              Submit Attendance
            </Button>
          </div>
        </div>
      </div>

      {/* Beneficiaries Table */}
      <div className="row">
        <div className="col-12">
          <Card className="shadow-sm">
            <CardHeader className="bg-light">
              <h5 className="mb-0">
                <i className="fas fa-table me-2"></i>
                Beneficiaries List
                <Badge color="info" className="ms-2">
                  {data?.length || 0} Total
                </Badge>
              </h5>
            </CardHeader>
            <CardBody className="p-0">
              <div className="ag-theme-alpine" style={{ height: '500px', width: '100%' }}>
 
                <AgGridReact
                  suppressMenuHide={true}
                  ref={gridRef}
                  onGridReady={(params) => {
                    // Grid ready
                  }}
                  rowSelection={"multiple"}
                  onRowSelectionChanged={onRowSelectionChanged}
                  rowData={data}
                  domLayout={"normal"}
                  animateRows={true}
                  pagination={true}
                  paginationPageSize={20}
                  defaultColDef={defaultColDef}
                  resizable={true}
                  enableCellTextSelection={true}
                  suppressCellSelection={true}
                  columnDefs={[
                    {
                      headerName: "#",
                      filter: false,
                      maxWidth: 70,
                      sortable: true,
                      valueFormatter: function (params) {
                        return `${parseInt(params.node.id) + 1}`;
                      },
                    },
                    {
                      headerName: "B-ID",
                      field: "beneficiary_inst_id",
                      sortable: true,
                      headerCheckboxSelection: true,
                      checkboxSelection: true,
                      filter: true,
                      pinned: 'left',
                      width: 120
                    },
                    {
                      headerName: "Name",
                      field: "name",
                      sortable: true,
                      filter: true,
                      width: 200
                    },
                    {
                      headerName: "Gender",
                      field: "gender",
                      sortable: true,
                      filter: true,
                      width: 100
                    },
                    {
                      headerName: "Age",
                      field: "age",
                      sortable: true,
                      filter: 'agNumberColumnFilter',
                      width: 80
                    },
                    {
                      headerName: "Card Issued",
                      field: "card_label",
                      sortable: true,
                      filter: true,
                      width: 120
                    },
                    {
                      headerName: "Telephone",
                      field: "telephone",
                      sortable: true,
                      filter: true,
                      width: 150
                    },
                    {
                      headerName: "Region",
                      field: "region_name",
                      sortable: true,
                      filter: true,
                      width: 150
                    },
                    {
                      headerName: "District",
                      field: "district_name",
                      sortable: true,
                      filter: true,
                      width: 150
                    },
                    {
                      headerName: "Village",
                      field: "village_name",
                      sortable: true,
                      filter: true,
                      width: 150
                    },
                    {
                      headerName: "Camp",
                      field: "camp_name",
                      sortable: true,
                      filter: true,
                      width: 150
                    },
                    {
                      headerName: "Registered On",
                      field: "registered_on",
                      sortable: true,
                      filter: true,
                      width: 150
                    }
                  ]}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      {/* Clock-ins Section */}
      <div className="row mt-4">
        <div className="col-12">
          <Card className="shadow-sm">
            <CardHeader className="bg-info text-white d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                <i className="fas fa-clock me-2"></i>
                Clock-ins History
                <Badge color="light" className="ms-2 text-dark">
                  {clockins?.length || 0} Total
                </Badge>
                {selectedClockins.length > 0 && (
                  <Badge color="warning" className="ms-2">
                    {selectedClockins.length} Selected
                  </Badge>
                )}
              </h5>
              <div className="d-flex gap-2">
                {selectedClockins.length > 0 && (
                  <Button
                    color="danger"
                    size="sm"
                    onClick={handleDeleteClick}
                    disabled={isDeleting}
                  >
                    <i className="fas fa-trash me-1"></i>
                    Delete Selected ({selectedClockins.length})
                  </Button>
                )}
                <Button
                  color="light"
                  size="sm"
                  onClick={loadClockins}
                  disabled={isLoadingClockins}
                >
                  {isLoadingClockins ? (
                    <>
                      <Spinner size="sm" className="me-2" />
                      Loading...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-sync me-1"></i>
                      Refresh
                    </>
                  )}
                </Button>
              </div>
            </CardHeader>
            <CardBody className="p-0">
              {isLoadingClockins ? (
                <div className="d-flex justify-content-center align-items-center py-5">
                  <Spinner color="info" />
                  <span className="ms-3">Loading clock-ins...</span>
                </div>
              ) : clockins.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-clock text-muted" style={{ fontSize: '3rem' }}></i>
                  <p className="text-muted mt-3 mb-0">No clock-ins found for this cycle</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th width="50">
                          <input
                            type="checkbox"
                            checked={clockins.length > 0 && selectedClockins.length === clockins.length}
                            onChange={(e) => handleSelectAllClockins(e.target.checked)}
                            className="form-check-input"
                          />
                        </th>
                        <th>#</th>
                        <th>Beneficiary Name</th>
                        <th>Telephone</th>
                        <th>Gender</th>
                        <th>Age</th>
                        <th>Clock-in Date & Time</th>
                        <th>Status</th>
                        <th>Created By</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clockins.map((clockin, index) => {
                        const statusBadge = clockin.status === 10001 
                          ? { color: 'success', text: 'Active' }
                          : { color: 'danger', text: 'Inactive' };
                        const isSelected = selectedClockins.includes(clockin.id);
                        
                        return (
                          <tr key={clockin.id} className={isSelected ? 'table-warning' : ''}>
                            <td>
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={(e) => handleClockinSelection(clockin.id, e.target.checked)}
                                className="form-check-input"
                              />
                            </td>
                            <td>{index + 1}</td>
                            <td>
                              <strong>{clockin.beneficiary?.name || 'N/A'}</strong>
                            </td>
                            <td>{clockin.beneficiary?.telephone || 'N/A'}</td>
                            <td>{clockin.beneficiary?.gender || 'N/A'}</td>
                            <td>{clockin.beneficiary?.age || 'N/A'}</td>
                            <td>
                              <i className="fas fa-calendar-alt me-1 text-primary"></i>
                              {clockin.clockin_date_time 
                                ? new Date(clockin.clockin_date_time).toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                  })
                                : 'N/A'}
                            </td>
                            <td>
                              <Badge color={statusBadge.color}>
                                {statusBadge.text}
                              </Badge>
                            </td>
                            <td>
                              {clockin.created_by ? (
                                <div>
                                  <div className="fw-bold">{clockin.created_by.name}</div>
                                  <small className="text-muted">{clockin.created_by.email}</small>
                                </div>
                              ) : 'N/A'}
                            </td>
                            <td>
                              {clockin.created_at 
                                ? new Date(clockin.created_at).toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                  })
                                : 'N/A'}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} toggle={() => setShowDeleteModal(false)} centered size="lg">
        <ModalHeader toggle={() => setShowDeleteModal(false)} className="bg-danger text-white">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Confirm Delete Clock-ins
        </ModalHeader>
        <ModalBody className="py-4">
          <div className="text-center mb-4">
            <i className="fas fa-trash-alt text-danger" style={{ fontSize: '3rem' }}></i>
          </div>
          
          <div className="row">
            <div className="col-12">
              <h5 className="text-center mb-4 text-dark">
                Are you sure you want to delete {selectedClockins.length} clock-in{selectedClockins.length !== 1 ? 's' : ''}?
              </h5>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Alert color="danger" className="text-center">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Warning:</strong> This action cannot be undone. The selected clock-in records will be permanently deleted.
              </Alert>
            </div>
          </div>

          {selectedClockins.length > 0 && selectedClockins.length <= 5 && (
            <div className="row mt-3">
              <div className="col-12">
                <h6 className="mb-2">Selected Clock-ins:</h6>
                <ul className="list-group">
                  {clockins
                    .filter(clockin => selectedClockins.includes(clockin.id))
                    .map((clockin) => (
                      <li key={clockin.id} className="list-group-item">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong>{clockin.beneficiary?.name || 'N/A'}</strong>
                            <br />
                            <small className="text-muted">
                              {clockin.clockin_date_time 
                                ? new Date(clockin.clockin_date_time).toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                  })
                                : 'N/A'}
                            </small>
                          </div>
                          <Badge color="danger">Delete</Badge>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter className="bg-light">
          <Button 
            color="secondary" 
            onClick={() => setShowDeleteModal(false)}
            className="me-2"
            disabled={isDeleting}
          >
            <i className="fas fa-times me-1"></i>
            Cancel
          </Button>
          <Button 
            color="danger" 
            onClick={handleConfirmDelete}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Spinner size="sm" className="me-2" />
                Deleting...
              </>
            ) : (
              <>
                <i className="fas fa-trash me-1"></i>
                Delete {selectedClockins.length} Clock-in{selectedClockins.length !== 1 ? 's' : ''}
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modern Confirmation Modal */}
      <Modal isOpen={showConfirmModal} toggle={() => setShowConfirmModal(false)} centered size="lg">
        <ModalHeader toggle={() => setShowConfirmModal(false)} className="bg-warning text-dark">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Confirm Attendance Submission
        </ModalHeader>
        <ModalBody className="py-4">
          <div className="text-center mb-4">
            <i className="fas fa-clipboard-check text-primary" style={{ fontSize: '3rem' }}></i>
          </div>
          
          <div className="row">
            <div className="col-12">
              <h5 className="text-center mb-4 text-dark">Please review the attendance details before submitting:</h5>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Card className="border-primary">
                <CardBody className="text-center">
                  <i className="fas fa-calendar-alt text-primary mb-2" style={{ fontSize: '2rem' }}></i>
                  <h6 className="text-muted mb-1">Date Range & Time</h6>
                  <p className="mb-0 fw-bold text-primary">
                    {startDate && endDate && clockinTime ? (
                      <>
                        {new Date(startDate).toLocaleDateString()} - {new Date(endDate).toLocaleDateString()}
                        <br />
                        <small>Time: {clockinTime}</small>
                        <br />
                        <small className="text-muted">({payload?.clockin_date_time?.length || 0} dates)</small>
                      </>
                    ) : (
                      'Not selected'
                    )}
                  </p>
                </CardBody>
              </Card>
            </div>
            <div className="col-md-6">
              <Card className="border-success">
                <CardBody className="text-center">
                  <i className="fas fa-users text-success mb-2" style={{ fontSize: '2rem' }}></i>
                  <h6 className="text-muted mb-1">Selected Beneficiaries</h6>
                  <p className="mb-0 fw-bold text-success">
                    {selectedCount} Beneficiary{selectedCount !== 1 ? 'ies' : ''}
                  </p>
                </CardBody>
              </Card>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12">
              <Alert color="info" className="text-center">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Note:</strong> This action will record attendance for all selected beneficiaries at the specified date and time. 
                This action cannot be undone.
              </Alert>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-light">
          <Button 
            color="secondary" 
            onClick={() => setShowConfirmModal(false)}
            className="me-2"
          >
            <i className="fas fa-times me-1"></i>
            Cancel
          </Button>
          <Button 
            color="success" 
            onClick={handleConfirmSubmit}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Submitting...
              </>
            ) : (
              <>
                <i className="fas fa-check me-1"></i>
                Confirm & Submit
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AttendanceList;
